import React from 'react'
import styled from 'styled-components'
import { ArrowRight } from '@styled-icons/bootstrap'
import { Dollar } from '@styled-icons/boxicons-regular'
import { Flash } from '@styled-icons/entypo'
import { Sun } from '@styled-icons/evaicons-solid'
import { Moon } from '@styled-icons/heroicons-solid'
import { device } from '../../../config/theme/breakpoints'
import TicketItem from '../../../features/change-destiny/components/ticket-item/ticket-item'
import FilterItem from '../../../features/change-destiny/components/filter-item/filter-item'

const ContainerTicket = styled.div`
  width: 95%;
  margin: auto;

  > div h3 {
    color:  ${p => p.theme.palette.primary.main};
    margin-bottom: 10px;
  }

  > div h3 svg {
    max-width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  @media ${device.tablet}{
    width: 90%;
  }
`
const ContainerFilter = styled.div`
  color: ${p => p.theme.palette.text.gray};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  @media ${device.tablet}{
    flex-direction: row;
  }
`
const ContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${p => p.theme.palette.text.gray};
  gap: 10px;
  flex-wrap: wrap;

  @media ${device.tablet}{
    justify-content: flex-end;
  }
`

const DestinyBar = styled.div`
  background: ${p => p.theme.palette.text.grayLight};
  border-radius: 4px 4px 15px 15px;
  position: relative;
  width: 100%;
  height: 8px;

  :after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20%;
    height: 8px;
    border-radius: 4px 4px 15px 15px;
    background: ${p => p.theme.palette.primary.main};
  }
`

const listFilter = [
  {
    icon: <Dollar />,
    text: 'Más barato'
  },
  {
    icon: <Flash />,
    text: 'Más Rápido'
  },
  {
    icon: <Sun />,
    text: 'Más Temprano'
  },
  {
    icon: <Moon />,
    text: 'Más Tarde'
  },
]

export interface IOption {
    id: number,
    icon: string,
}

interface IOwnProps {
    type: string;
    inclination: string;
    seatingNumber: string;
    price: string;
    initTime: string;
    arrivalTime: string;
    fromCity: string;
    toCity: string;
    time: string;
    listOptions: IOption[];
    onClick?: () => void;
}

const OfferTicketItem: React.FunctionComponent<IOwnProps> = ({
    type,
    inclination,
    seatingNumber,
    price,
    initTime,
    arrivalTime,
    fromCity,
    toCity,
    time,
    listOptions = [],
    onClick = () => console.log
}) => {
    return (
        <ContainerTicket>
            <div>
              <h3>
                Origen
                <ArrowRight />
                Chiclayo
              </h3>
            </div>
            <DestinyBar />
            <ContainerFilter>
              <div>Resultados: 5</div>
              <ContainerFilters>
                <div>Ordenar por:</div>
                {listFilter.map(filter => (
                  <FilterItem icon={filter.icon} text={filter.text}/>
                ))}
              </ContainerFilters>
            </ContainerFilter>
              <TicketItem
                  type={type}
                  inclination={inclination}
                  seatingNumber={seatingNumber}
                  price={price}
                  initTime={initTime}
                  arrivalTime={arrivalTime}
                  fromCity={fromCity}
                  toCity={toCity}
                  time={time}
                  listOptions={listOptions}
              />
        </ContainerTicket>
    )
}
export default OfferTicketItem